import { addGTMEvent } from ".";
import { DataLayerEvent } from "./types";

type VideoAction = "play" | "pause" | "completed";

export const trackVideo = (action: VideoAction): void => {
  const data = {
    event_category: "Video Tracking",
    event_action: action
  };

  addGTMEvent({ name: DataLayerEvent.VideoTracking, data });
};
